// extracted by mini-css-extract-plugin
module.exports = {"modal-auth":"styles_modal-auth__htOdD"};